// Copyright ©️ 2026 eVolve MEP, LLC

import type { ReactNode } from 'react';

import { Card, Table } from '@mantine/core';

type Props = {
  title: string;
  /** Accepts a list of Table.Trs */
  children: ReactNode;
};

export const NotificationSettingsSection = ({ title, children }: Props) => (
  <Card withBorder padding={0}>
    <Table striped="even" horizontalSpacing="md" verticalSpacing="sm">
      <Table.Thead bg="gray.1">
        <Table.Tr>
          <Table.Th>{title}</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{children}</Table.Tbody>
    </Table>
  </Card>
);
